// reupload
// reuplaod
// sdfasdf
// why this no work
// sdfasdf
// sdfas

import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import { ReactComponent as ArrowRight } from './reshot-icon-arrow-left-4NA6KJF8CU.svg';
import { ReactComponent as ArrowLeft } from './reshot-icon-arrow-right-ZP2WDL9B8N.svg';
import automatedCalendarImage from './images/Events.png';
import googleAiImage from './images/Googleai.png'
import jewelry from './Screenshot 2025-05-08 at 9.59.35 AM.png'
import { ReactComponent as Icon1 } from './svg/python-svgrepo-com.svg';
import { ReactComponent as Icon2 } from './svg/react-svgrepo-com.svg';
import { ReactComponent as Icon3 } from './svg/gemini-logo.svg';
import { ReactComponent as Icon4 } from './svg/c-plusplus.svg';
import { ReactComponent as Icon5 } from './svg/docker-svgrepo-com.svg';
import { ReactComponent as Icon6 } from './svg/javascript-svgrepo-com.svg';
import { ReactComponent as Icon7 } from './svg/mysql-svgrepo-com.svg';
import { ReactComponent as Icon8 } from './svg/html-document-svgrepo-com.svg';
import { ReactComponent as Icon9 } from './svg/git-svgrepo-com.svg';
import { ReactComponent as Icon10 } from './svg/linux-svgrepo-com.svg';
import {ReactComponent as Icon11} from "./svg/terminal-svgrepo-com.svg"
import {ReactComponent as Icon12} from "./svg/server-svgrepo-com.svg"
import {ReactComponent as Icon13} from "./svg/css-file-web-svgrepo-com.svg"
import socalFurspng from './images/SocalFursUpdated.png'
import socalmap from "./images/socalmap.png"
import amatuer from "./AmatuerGolf.png"
// import contact from './contact.gif'
import './HomePage.css'


// Carousel Component :3
const Carousel = ({ data }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    if (slide === data.length - 1) 
    {
      setSlide(0);
    } else 

    {
      setSlide(slide + 1);
    }
  };
  
  const prevSlide = () => {
    if (slide === 0) {
      setSlide(data.length - 1);
    } else 
    
    {
      setSlide(slide - 1);
    }
  };

  return (
    <div className="carousel">
      <ArrowLeft onClick={prevSlide} id = "arrow-left-left" className="arrow arrow-left" />
      {data.map((item, idx) => {
        return (
          <img
            src={item.src}
            alt={item.alt}
            key={idx}
            className={slide === idx ? "slide" : "slide slide-hidden"}
          />
        );
      })}
      <ArrowRight
        onClick={nextSlide}
        className="arrow arrow-right"
      />
      <span className="indicators">
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};


export default function HomePage() {

  const data = [
    {src: socalFurspng, alt: "socalfurs.com"},
    {src: socalmap, alt: "socalfurmap"},
    { src: automatedCalendarImage, alt: "Automated Calendar" },
    { src: googleAiImage, alt: "Automated Calendar" },
  ];
    const data2 = [
    {src: amatuer, alt: "amatuergolf.com"},

  ];


  return (

    <div className="App">

        <div className = "home-page-container">
            
        <div className="green-line-bottom"> 

          <div className="link-container">

              <heading className="para-2"> 👋 Hi There I'm Avry! </heading>
            <p className = "para">- I'm a recent graduate Software engineer with experience in full-stack development, Python automation, and AI-powered tools.</p>
            <p className="link-text"> Experience: <Link style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to = "/experience">Experience Page </Link></p>
            <p className="link-text"> GitHub:    <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }} href="https://github.com/avryjacksoncom" > GitHub  </a></p>
            <p className="link-text"> Linkedin: <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href="https://www.linkedin.com/in/avry-jackson-886529265/"> Linkedin   </a></p>
            <p className="link-text"> Email:    <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href="mailto:avry.jackson@hotmail.com" >  avry.jackson@hotmail.com </a></p>
            <p className="link-text"> View My Resume: <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }} href="/Resume.pdf" target="_blank" rel="noopener noreferrer"> Resume.pdf</a></p>
            <p className="link-text"> Projects: <Link style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to = "/projects">Project Listing </Link></p>
          </div> 
          

      
                   <div className = "green-line-bottom">
                
                   </div>

                     <div className = "container-carousel">
                      <header style={{fontSize:28}}className="header-avry2">Professional Experience </header>
                            {/* <a href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                             <a href = "https://www.amateurgolf.com/"><h1 id = "jewelryexchange1" style ={{color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}className = "header-avry3">Software Engineer: AmatuerGolf.com</h1></a>
                          {/* <header id = "jewelryexchange1" className="header-avry2">Current Employment </header> */}
                          
                         {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                         {/* <a style={{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href = "https://www.amateurgolf.com/"><header className = "header-avry2"style = {{ fontSize:24,color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}>Software Dev: Amateurgolf.com</header></a> */}
                         <img className = "img-ag" src={amatuer}></img>
                       <header className="header-avry3">Tech Stack: </header>
                         <div className="icon-group">
                           <div className="icon-item">
                             <Icon1 className="icon-img" title="Python" />
                             <p className="icon-label">Python</p>
                           </div>
                           <div className="icon-item">
                             <Icon2 className="icon-img" title="React" />
                             <p className="icon-label">React</p>
                           </div>
                           <div className="icon-item">
                             <Icon3 className="icon-img" title="Gemini AI" />
                             <p className="icon-label">Gemini AI</p>
                           </div>
                         </div>
                         {/* <Link style={{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to ="/socalfurs"><h3>Project Details</h3></Link> */}
                            <p style={{fontSize:18.1}} className = "paragraph-about-me">
                   Currently a software developer at AmateurGolf, where I’m building tools to streamline workflows for their 
                   writers across multiple applications. I’m creating systems that automate repetitive tasks, integrate data 
                   from different sources, and help writers focus on content creation rather than manual processes. 
                   Using Python and other technologies, I’m developing solutions that improve efficiency and support a 
                   growing team of content creators.
                         </p>
             
                       {/* end of carousel compenent container */}
                       </div>
                             <div className = "green-line-bottom">
                
                   </div>
             <div className = "container-carousel">
                          <header style={{fontSize:28}}className="header-avry2">Professional Experience </header>
                         {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                         <a style={{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href = "https://socalfurs.com/"><header className = "header-avry2"style = {{ fontSize:24,color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}>Lead Dev: Socalfurs.com</header></a>
                         <Carousel data={data} />
                       <header className="header-avry3">Tech Stack: </header>
                         <div className="icon-group">
                           <div className="icon-item">
                             <Icon1 className="icon-img" title="Python" />
                             <p className="icon-label">Python</p>
                           </div>
                           <div className="icon-item">
                             <Icon2 className="icon-img" title="React" />
                             <p className="icon-label">React</p>
                           </div>
                           <div className="icon-item">
                             <Icon3 className="icon-img" title="Gemini AI" />
                             <p className="icon-label">Gemini AI</p>
                           </div>
                         </div>
                         <Link style={{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to ="/socalfurs"><h3>Project Details</h3></Link>
                            <p style={{fontSize:18.1}} className = "paragraph-about-me">
                           I'm the lead developer for SocalFurs. I created an automated calendar to make the furry fandom easier to access
                            for people who might not know much about it.Many discover the community only through personal connections, 
                            so I wanted to build a tool that helps anyone find
                           and join events easily. Using Python, Google AI, and React, I developed a system that converts Telegram messages 
                           into Google Calendar events, serving a community of over 3,000 members and 100 organizers. It handles thousands of
                            updates each week and syncs every few minutes to stay accurate. I also built a companion website so people can browse 
                           and search events easily, helping both newcomers and organizers save time.
                         </p>
             
                       {/* end of carousel compenent container */}
                       </div>
                    
                    
                
                 </div>


            
                
                  
              {/* Carousel Component */}
        
               {/* Carousel Component */}
                 <div className = "green-line-bottom"> 
                            <div className = "container-carousel">
                              <header style={{fontSize:28}}className="header-avry2">Professional Experience </header>
                            {/* <a href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                             <h1 id = "jewelryexchange1" style ={{color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className = "header-avry3">Jewelry Exchange In-Store Customer Survey</h1>
                             <img className = "image-jewelry" alt = "jewelry" src={jewelry}></img>
                                <header className="header-avry3">Details: Freelance</header>
                             <div className="icon-group">
                               <div className="icon-item">
                                 <Icon1 className="icon-img" title="Python" />
                                 <p className="icon-label">Python</p>
                               </div>
                               <div className="icon-item">
                                 <Icon2 className="icon-img" title="React" />
                                 <p className="icon-label">React</p>
                               </div>
                             </div>
                             <p style = {{fontSize:18.1}}className = "paragraph-about-me">
                             I built a simple customer survey system using FastAPI and React to track how people hear about us. 
                             Customers scan a QR code in the store and select where they found us, like Google or Bing, 
                             and their responses are saved in a CSV file. This helps our managers see which ads are working without 
                             relying on employees to remember to ask. The system now gets over 25 responses each weekend and gives 
                             us real data to guide some of our marketing efforts. I also automated duplicate detection in a 
                             directory of over 12,000 images using Python, 
                             successfully deleting more than 200 redundant files and streamlining storage management.
                             </p>
             
                                 {/* <Carousel data={data2} /> */}
             
                           {/* end of carousel compenent container */}
                           </div>

           
              </div>

              <div></div>

                <div className = "green-line-bottom"> 
                        <header style = {{ fontSize:26,color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className="header-about-me-2"> Current: </header>
                            <div className = "current-container">
                                                 
                    <p className="paragraph-about-me-3"> Currently working for amatuergolf.com as a full-stack software developer. Making tools for the team, and enhancing 
                      the website. I work with the entire codebase of amtauergolf.com. Documenting, fixing bugs, and maintaining. On my own time, I am Working on 
                      my mapping project that can be hopefully be used for any location that needs extra local mapping assistance!
              
    

                  </p>

                            </div>
                 
                </div>
           
              <div className = "green-line-bottom"> 
          {/* Past continer */}
             <header style = {{ fontSize:26,color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}  className="header-about-me-2"> Past: </header>
          <div className = "current-container">
                 
            
              <p className="paragraph-about-me-3">Before attending CSUDH,
                I studied at Irvine Valley College and Saddleback College, where I earned my A.S.
                degree in Liberal Arts.
              </p>
    
          </div>
            
            {/* End of Past Container */}
         
              </div>

            <div className = "green-line-bottom"> 
              <header style = {{ fontSize:26,color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className="header-about-me-2"> Experience: </header>
                <div className = "current-container">

                                            <p className="paragraph-about-me-3">
                Here are some of my <Link style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to = "/experience">Experiences</Link> I have with software engineering.
                You can check out my other projects as well here:  
                  <Link style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to = "/projects" > Projects</Link>
              </p>
                </div>
  
    
        
           
            {/* End of Projects container */}
    
      
          </div>
              {/* <div className = "green-line-bottom">
                
                   </div> */}
                  {/* Skills continer */}
          <div className = "green-line-bottom">
                    <div className = "current-container">
                  
                      <header style = {{ fontSize:26,color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className="header-about-me-2"> Current skills: </header>
          
                      <p className="paragraph-about-me-3">Below are the
                              languages and frameworks I am currently learning.
                      </p>
                  </div>
           

            {/* End of Skills Container */}
            {/* </div> */}

            {/* {/* <div className = "green-line-bottom"> */}
       
          </div>
        {/* Icon grid */}


        <div className="space-grid">

        </div>
        <div className = "green-line-bottom-2">

          
        </div>
              <div className="grid-container">
                <ul className="grid-line">
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon1 className="icon-img" />
                      <span className="tooltip">70%</span>
                      <p className="icon-label">Python</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon2 className="icon-img" />
                        <span className="tooltip">60%</span>
                      <p className="icon-label">React</p>
                      
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon3 className="icon-img" />
                      <span className="tooltip">80%</span>
                      <p className="icon-label">Gemini AI</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon4 className="icon-img" />
                       <span className="tooltip">50%</span>
                      <p className="icon-label">C++</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon5 className="icon-img" />
                        <span className="tooltip">60%</span>
                      <p className="icon-label">Docker</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon6 className="icon-img" />
                      <span className="tooltip">70%</span>
                      <p className="icon-label">Javascript</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon7 className="icon-img" />
                      <span className="tooltip">80%</span>
                      <p className="icon-label">MySql</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon8 className="icon-img" />
                      <span className="tooltip">90%</span>
                      <p className="icon-label">HTML</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon9 className="icon-img" />
                      <span className="tooltip">80%</span>
                      <p className="icon-label">Git</p>
                    </div>
                  </li>
                  <li className="icons">
                    <div className="icon-wrapper">
                      <Icon10 className="icon-img" />
                      <span className="tooltip">60%</span>
                      <p className="icon-label">Linux</p>
                    </div>
                  </li>
                   <li className="icons">
                    <div className="icon-wrapper">
                      <Icon11 className="icon-img" />
                      <span className="tooltip">85%</span>
                      <p className="icon-label">Terminal</p>
                    </div>
                  </li>
                    <li className="icons">
                    <div className="icon-wrapper">
                      <Icon12 className="icon-img" />
                      <span className="tooltip">60%</span>
                      <p className="icon-label">Servers</p>
                    </div>
                  </li>
                       <li className="icons">
                    <div className="icon-wrapper">
                      <Icon13 className="icon-img" />
                      <span className="tooltip">60%</span>
                      <p className="icon-label">CSS</p>
                    </div>
                  </li>
                  
                </ul>
              </div>

  
        {/* Home-page-container div */}
        </div>

    {/* End of entire div */}
    </div>
  );
}
